// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1dsMZ","label":"Radio_label__3aIuQ","checkMark":"Radio_checkMark__39h9e","disabled":"Radio_disabled__3DJoi"};